import axios from 'axios';
import { v4 as uuidV4 } from 'uuid';
import { getAuthorization } from './utils';
import { getCached } from '../components/common';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const pool = axios.create({ baseURL: process.env.REACT_APP_POOL_URL });
export const velux = axios.create({ baseURL: process.env.REACT_APP_VELUX_URL });
export const bpApi = axios.create({ baseURL: process.env.REACT_APP_BP_API_URL });

const v1Instance = {
  pool,
  velux,
};

export const initiateInspection = async (type, resources) => {
  const result = await v1Instance[type].post('/', resources);
  return result;
};

export const initiateInspectionReq = async (resources, itemTypes) => {
  const authorization = getAuthorization();
  const userId = getCached.whoamiId();

  return await Promise.all(
    itemTypes.map(item => {
      return instance.put(`/users/${userId}/detectionJobs`, { ...resources, id: uuidV4(), featureType: item }, { headers: { authorization } });
    })
  );
};
